import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PRODUCT } from '../../../constants/queryKeys';
import productApiV2 from '../../../lib/api/product/ProductApiV2';
import { QueryOptions } from '../../../types/query/useQuery';
import { CustomFieldDefinitionsResponseDto } from '../../../types/api/product-custom-fields';

type ProductCustomFieldDefinitionsResponse = CustomFieldDefinitionsResponseDto;

type UseProductCustomFieldDefinitionsArgs<SelectResultType> = {
  options?: QueryOptions<ProductCustomFieldDefinitionsResponse, unknown, SelectResultType>;
};

export const useProductCustomFieldDefinitions = <SelectResultType = ProductCustomFieldDefinitionsResponse>({
  options,
}: UseProductCustomFieldDefinitionsArgs<SelectResultType> = {}): UseQueryResult<SelectResultType, unknown> => {
  return useQuery<ProductCustomFieldDefinitionsResponse, unknown, SelectResultType>(
    PRODUCT.CUSTOM_FIELD_DEFINITIONS,
    (): Promise<ProductCustomFieldDefinitionsResponse> => productApiV2.getProductCustomFieldDefinitions(),
    {
      ...options,
    },
  );
};

export default useProductCustomFieldDefinitions;
